<div id="culture-music" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Cultural Activities</h2>
    <p class="inner-lead mt-3">
      At Shah Satnam Ji Girls' College, Sirsa, we believe that cultural activities are the heart and soul of our
      institution. Our vibrant campus is always buzzing with enthusiasm and creativity as we celebrate a myriad of
      cultural festivals and events with grandeur and zeal.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Festivals and Celebrations</h4>
    <p>We celebrate major festivals like Holi, Diwali, Vaisakhi, and Lohri, bringing together students and staff in a
      harmonious blend of colours, lights, and traditions. Each festival is marked by unique activities that highlight
      the cultural richness of our diverse student body.</p>

    <h4 class="section-subtitle mt-4">Talent Hunt Show and Cultural Performances</h4>
    <p>Our Talent Hunt show is a much-anticipated event, showcasing the diverse talents of our students. From
      mesmerizing dance performances and soulful singing to intricate mehndi designs and vibrant rangoli creations, our
      students leave no stone unturned in demonstrating their skills.</p>

    <h4 class="section-subtitle mt-4">Fresher Welcome, Farewell, and Induction Program</h4>
    <p>Welcoming new students with warmth and enthusiasm, our Fresher Welcome event is a grand celebration, featuring a
      variety of cultural performances and activities. Similarly, our Farewell ceremony is a heartfelt send-off,
      celebrating the achievements and memories of our graduating students. The Induction Program introduces new
      students to the vibrant culture of our college, setting the tone for their journey ahead.</p>

    <h4 class="section-subtitle mt-4">Youth Festival Participation</h4>
    <p>Our students actively participate in the Youth Festival, representing the college with pride and excellence.
      Their performances in dance, singing, drama, and other cultural events have garnered numerous accolades,
      showcasing the exceptional talent and dedication of our student community.</p>
    <p>Our students won prizes in Singing, Dance, Mehndi, Rangoli and Declamation contests held by other institutions.
      These activities are just like "Cultural Fusion: Uniting Hearts and Minds".</p>

    <h4 class="section-subtitle mt-4">Creative Arts and Crafts</h4>
    <p>Students at Shah Satnam Ji Girls' College also engage in various arts and crafts activities. From diya decoration
      during Diwali to face painting and nail art, these activities allow students to express their creativity and
      artistic flair.</p>

    <h4 class="section-subtitle mt-4">Cultural Shows and Dress Competitions</h4>
    <p>Our cultural shows are a vibrant display of traditional attire and customs. Students participate in dress
      competitions, donning ethnic outfits that reflect the cultural heritage of different regions, fostering a sense of
      unity and appreciation for diversity.</p>

    <p class="mt-3">At Shah Satnam Ji Girls' College, Sirsa, cultural activities are not just events; they are an
      integral part of our educational experience, fostering creativity, unity, and a deep appreciation for our rich
      cultural heritage. We take immense pride in our students' participation and achievements, which contribute to the
      vibrant and dynamic atmosphere of our college.</p>

    <hr class="divider">

    <h4 class="section-subtitle">Cultural Activity Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/cultural-activities/Cultural-Activities-2023-24.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Cultural Activities 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/cultural-activities/Cultural-Activities-2022-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Cultural Activities 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/cultural-activities/Cultural-Activities-2021-22.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Cultural Activities 2021-22
        </a>
      </div>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Photo Gallery</h4>
    <div class="row g-3 mt-2 mb-4">
      <div class="col-6 col-md-3" *ngFor="let img of culturalImages">
        <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
          <img [src]="img" alt="Cultural Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px;">
        </div>
      </div>
    </div>

  </div>
</div>